export enum SchoolCreate{
   ADD =  0,
   EDIT = 1,
   VIEW = 2
}